import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import ROUTES from '../../routes';
import api from '../../config/axiosInstance';

import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';
import DetailModal from '../../Components/DetailModal';

const CtaRequests = () => {
    const Swal = window.Swal;

    const limit = 10;
    const [ctaRequests, setCtaRequests] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    useEffect(() => {
        const fetchCtaRequests = async (page = 1) => {
            try {
                setLoading(true);
                const offset = (page - 1) * limit;
                const res = await api.get(`/cta/list?limit=${limit}&offset=${offset}`);
                if (res.status === 200) {
                    console.log(res.data.ctaRequests)
                    setCtaRequests(res.data.ctaRequests || []);
                    const total = res.data.total || 0;
                    setTotalPages(Math.ceil(total / limit) || 1);
                }
            } catch (err) {
                handleErrors(err);
            } finally {
                setLoading(false);
            }
        };

        fetchCtaRequests(currentPage);
    }, [currentPage]);

    const handleViewDetail = async (id) => {
        try {
            setModalLoading(true);
            setShowModal(true);
            const res = await api.get(`/cta/${id}`);
            if (res.status === 200) {

                let data = res.data.ctaRequest

                setModalData(data);
            }
        } catch (err) {
            handleErrors(err);
            setShowModal(false);
        } finally {
            setModalLoading(false);
        }
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            html: '<i class="fas fa-trash-alt" style="font-size: 42px; color: #d33; margin-bottom: 10px;"></i><p>This will permanently delete the subscriber!</p>',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await api.delete(`/cta/${id}`);
                    if (res.status === 200) {
                        showToast('success', res.data.message || 'CTA deleted successfully', 'Deleted');
                        setCtaRequests(prev => prev.filter(s => s._id !== id));
                    }
                } catch (err) {
                    handleErrors(err);
                }
            }
        });
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.ROOT}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={ROUTES.CTA_REQUESTS}>CTA Requests</Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">CTA Requests</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                {loading ? (
                                    <div className="text-center my-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <table className="table table-responsive-md">
                                        <thead>
                                            <tr>
                                                <th><strong>#</strong></th>
                                                <th><strong>Name</strong></th>
                                                <th><strong>Email</strong></th>
                                                <th><strong>Phone</strong></th>
                                                <th><strong>Company Name</strong></th>
                                                <th><strong>Product Interested</strong></th>
                                                <th><strong>Actions</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ctaRequests && ctaRequests.length > 0 ? ctaRequests.map((ctaRequest, index) => (
                                                <tr key={ctaRequest._id || index} style={{ cursor: 'pointer' }}>
                                                    <td><strong>{((currentPage - 1) * limit) + (index + 1)}</strong></td>
                                                    <td>{ctaRequest.name || 'N/A'}</td>
                                                    <td>{ctaRequest.email || 'N/A'}</td>
                                                    <td>{ctaRequest.phone || 'N/A'}</td>
                                                    <td>{ctaRequest.company_name || 'N/A'}</td>
                                                    <td>{ctaRequest.product}</td>
                                                    <td>
                                                        <div className="d-flex" onClick={(e) => e.stopPropagation()}>
                                                            <button
                                                                className="btn btn-primary shadow btn-xs sharp me-1"
                                                                onClick={() => handleViewDetail(ctaRequest._id)}
                                                            >
                                                                <i className="fas fa-eye"></i>
                                                            </button>
                                                            <button
                                                                className="btn btn-danger shadow btn-xs sharp"
                                                                onClick={() => handleDelete(ctaRequest._id)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">No CTA requests found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                        <div className="card-footer">
                            <ul className="pagination pagination-gutter pagination-primary no-bg">
                                <li className={`page-item page-indicator ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <a className="page-link" href="#/" onClick={(e) => { e.preventDefault(); setCurrentPage(prev => Math.max(prev - 1, 1)); }}>
                                        <i className="la la-angle-left"></i>
                                    </a>
                                </li>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <li className={`page-item ${currentPage === i + 1 ? 'active' : ''}`} key={i}>
                                        <a className="page-link" href="#/" onClick={(e) => { e.preventDefault(); setCurrentPage(i + 1); }}>{i + 1}</a>
                                    </li>
                                ))}
                                <li className={`page-item page-indicator ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <a className="page-link" href="#/" onClick={(e) => { e.preventDefault(); setCurrentPage(prev => Math.min(prev + 1, totalPages)); }}>
                                        <i className="la la-angle-right"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <DetailModal
                show={showModal}
                onHide={() => setShowModal(false)}
                title="CTA Request Detail"
                data={modalData}
                loading={modalLoading}
            />
        </>
    );
};

export default CtaRequests;
